module.exports = __webpack_public_path__ + "static/media/lumimax.30e2bc71.png";